module.exports = __webpack_public_path__ + "img/iconfinder_duplicate_3017914.f0c4ca15.svg";